var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-page"},[(_vm.isLoading)?_c('Load'):_vm._e(),(_vm.campaign)?[_c('CustomerInformationForm')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }